export default __webpack_public_path__ + "static/media/users-green.26f8fed3.svg";